<div class="pt-8">
  <h2 class="text-center text-gray-700">Bem vindo ao sistema tg.mob</h2>
</div>
